import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import tr from '@/common/utils/tr';
import useTranslationSubscription from '@/hooks/useTranslation';
import {
    getFieldMeta,
    getFieldLabel,
    openaiConnectorList
} from '../../handler/MCPServerUIHandler';

const getScopeToCNN = (selectConnectorId) => {
    let connectorObject = openaiConnectorList.find(conn => conn.value === selectConnectorId);
    if (!connectorObject) return [];
    return connectorObject.scopes;
};

const RenderMCPSelectField = memo(({ 
    fieldKey, 
    fieldValue, 
    errors, 
    formData,
    onChange, 
    onBlur,
    optionList
}) => {
        useTranslationSubscription();
        
        const meta = getFieldMeta(fieldKey);
        const isRequired = meta.required || false;
        const errorMsg = errors[fieldKey] || '';
        
        const selectOnChange = (newValue) => {
            onChange(fieldKey, newValue);
            if (fieldKey === Constant.MCP_SERVER_TEXT.OPENAI_CONNECTOR) {
                const oauth2Setting = formData?.oauth2Setting || {};
                let scopeToCNN = getScopeToCNN(newValue);
                oauth2Setting.scope = scopeToCNN;
                onChange(Constant.AUTH_METHOD_MCP_SERVER.OAUTH2_SETTING, oauth2Setting);
            }
        }

        return (
            <div key="auth-section">
                <div className="api-field-wrapper">
                    <h4 className="api-field-label">
                        {getFieldLabel(fieldKey)}{' '}
                        {isRequired && <span style={{ color: 'red' }}>*</span>}
                    </h4>
                    <TextField
                        className="form-control-wrapInput api-field-input"
                        select
                        variant="outlined"
                        data-cy="auth-method-select"
                        value={fieldValue}
                        error={!Utils.isEmptyString(errorMsg)}
                        helperText={errorMsg}
                        onChange={e => selectOnChange(e.target.value)}
                        onBlur={e => onBlur(fieldKey, e.target.value, meta)}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null
                            },
                            onClose: e => {
                                onBlur(fieldKey, fieldValue || e.target.innerText, meta);
                            }
                        }}
                    >
                        {optionList.map((option) => (
                            <MenuItem data-cy="auth-method-item" key={option.label} value={option.value} disabled={option?.isdisable}>
                                {tr(option.label)}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>

            </div>
        );
    }
);

RenderMCPSelectField.propTypes = {
    fieldKey: PropTypes.any,
    fieldValue: PropTypes.any,
    errors: PropTypes.any,
    authData: PropTypes.any,
    onChange: PropTypes.any,
    onBlur: PropTypes.any,
    handleRunAuth: PropTypes.any,
    RenderField: PropTypes.any
};

export default RenderMCPSelectField;


